<div class="link-bar">
  <div class="app-selector-wrapper row">
    <div class="col-auto">
      <a class="logo" href aria-label="MyLion Menu" (click)="toggleMenu($event)">
        <mat-icon>apps</mat-icon>
      </a>
      <span>
        <a href class="app-selector" (click)="toggleMenu($event)"><span>MyLion</span>
        </a>
      </span>
    </div>
    <div class="col">
      <div class="menu-wrapper">
        <a *ngFor="let link of links" href routerLinkActive="active" [ngClass]="{ 'link-active' : link.active == true }"
          (click)="travelLink(link, $event)">{{ link.label }}</a>
      </div>
    </div>
    <div class="user-menu" *ngIf="menuToggled" #userMenu>
      <div class="application-head" translate="lblApplications">Applications</div>
      <div class="row">
        <div class="col">
          <p class="close-icon">
            <img style="cursor: pointer;" (click)="closeMenu()" src="/assets/images/close_icon.png" />
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col menu-body">
          <span class="menu-group">
            <div class="application" (click)="navigateToUrl(application.applicationUrl)"
              *ngFor="let application of applications">
              <div>
                <span class="img-center-helper"></span>
                <img [src]="application.imageUrl" />
              </div>
              <span class="title"
                *ngIf="application.applicationName != userClaim.ShopJapan">{{application.applicationName}}</span>
              <span class="title" *ngIf="application.applicationName == userClaim.ShopJapan">Shop</span>
            </div>

          </span>
        </div>
        <!--        <div class="col" style="text-align: center;">-->
        <!--          <span class="menu-group"> </span>-->
        <!--        </div>-->
        <!--        <div class="col" style="text-align: center;">-->
        <!--          <span class="menu-group"> </span>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</div>